export const getEnableOperatorVerification = (state) => {
  return state?.companySettings?.enableOperatorVerification ?? false;
};
